import React from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from '@mantine/core';
import { IconX } from "@tabler/icons-react";
import { notifications } from '@mantine/notifications';
import TestsApi from "../../api/TestsApi";

export function AddToFunnel({
    SelectedThumbnail,
    SelectedTaguchiId,
    SelectedMemberWebsite,
    SelectedFunnelId,
    SelectedTestId,
    setOpenSetWinnerModel,
    selectedPageClass
  }:any) {

  const navigate = useNavigate();

  const handleAddtoFunnel = async () => {
    try {
      const APIResponse = await TestsApi.checkpageinfunnelvalidation({
        page_id: SelectedThumbnail,
        taguchi_test_id: SelectedTaguchiId,
        system_website_id : SelectedMemberWebsite
      });
      const APIResultJSON = await APIResponse.json();
      if (APIResultJSON.status === 1) {
        if(selectedPageClass === "page discarded_by_cron" || selectedPageClass === "Test-Completed"){
          setOpenSetWinnerModel(true);
        }else{
          navigate("/reviewing-test", { state: { pageId: SelectedThumbnail, taguchiTestId: SelectedTaguchiId, funnelId:SelectedFunnelId, testsId:SelectedTestId} });
        }
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: APIResultJSON.message,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  }

  return (
    <>
      <Button type="button" style={{ marginLeft: "auto" }} onClick={() => handleAddtoFunnel()}>
        Select
      </Button>
    </>
  );
}